export const DRIVER_EVENTS = {
  RIDE_OFFER: 'ride:offer',
  RIDE_OFFER_DISMISSED: 'ride:offer_dismissed',
  RIDE_UPDATED: 'ride:updated',
  RIDE_ASSIGNED: 'ride:assigned',
  RIDE_DRIVER_ASSIGNED: 'ride:driver_assigned',
  RIDE_ACCEPTED: 'ride:accepted',
  RIDE_ACCEPT_ERROR: 'ride:accept_error',
  RIDE_REJECTED: 'ride:rejected',
  RIDE_REJECT_ERROR: 'ride:reject_error',
  RIDE_ARRIVED: 'ride:arrived',
  RIDE_ARRIVE_ERROR: 'ride:arrive_error',
  RIDE_STARTED: 'ride:started',
  RIDE_START_ERROR: 'ride:start_error',
  RIDE_COMPLETED: 'ride:completed',
  RIDE_COMPLETE_ERROR: 'ride:complete_error',
  RIDE_CANCELLED: 'ride:cancelled',
  CURRENT_RIDE: 'current_ride',
  STATUS_UPDATED: 'status_updated',
  DRIVER_STATS: 'driver_stats',
  LOCATION_UPDATED: 'location_updated',
} as const;

export type DriverEventType = typeof DRIVER_EVENTS[keyof typeof DRIVER_EVENTS];

